<div class="d-flex flex-row justify-content-end mt-5px" *ngIf="isSingle">
  <div *ngFor="let platform of platformList" class="{{platform.name.toLowerCase() + '-icon platform-icon-wrapper'}}"
       [ngClass]="{'disabled-icon': !hasPlatform(platform.id, influencer)}">
  </div>
</div>
<div class="d-flex flex-row justify-content-end" *ngIf="isUnknownInfluencer">
  <a class="add-influencer-manually-link underline-link" (click)="addNewInfluencer()">
    <div>({{'add_influencer_manually.link_lable' | translate}})</div>
    <div class="bottom-line-link add-manually"></div>
  </a>
</div>

<div class="d-flex flex-row justify-content-end" *ngIf="isProcessing">
  <div class="add-influencer-manually-link processing-link">
    <div>{{'add_influencer_manually.is_processing' | translate}}</div>
  </div>
  <div class="influencer-status-icon">
    <achoo-loader [normalPlaceholder]="true"></achoo-loader>
  </div>
</div>

<div class="d-flex flex-row justify-content-end" *ngIf="isMultiple">
  <div class="add-influencer-manually-link multiple">{{'add_influencer_manually.multiple_result' | translate}}</div>
  <a class="add-influencer-manually-link underline-link" (click)="openMultipleSelection()">
    <div>{{'add_influencer_manually.link_multiple' | translate}}</div>
    <div class="bottom-line-link"></div>
  </a>
</div>

<div class="d-flex flex-row justify-content-end" *ngIf="hasError">
  <div class="add-influencer-manually-link">{{'add_influencer_manually.error_message' | translate}}</div>
  <a class="add-influencer-manually-link underline-link" (click)="retryAddInfluencer()">
    <div>{{'add_influencer_manually.error_link' | translate}}</div>
    <div class="bottom-line-link"></div>
  </a>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/add-influencer-group/status-influencer-suggestion/status-influencer-suggestion.component.html